<template>
  <component>
    <li class="upperSidebar__item">
      <div
        class="upperSidebar__link"
        :class="{ 'upperSidebar__link--active': isActiveLink }"
        @click="selectPage(routeName)"
      >
        {{ name }}
      </div>
      <div v-if="notifications && Object.keys(notifications).length > 0" class="upperSidebar__item-notification">
        {{ Object.keys(notifications).length }}
      </div>
    </li>
  </component>
</template>

<script>
export default {
  name: 'UpperSidebarLink',
  props: {
    name: {
      type: String,
    },
    routeName: {
      type: String,
    },
    category: {
      type: Object,
    },
  },
  data: function () {
    return {
      notifications: null,
    };
  },
  computed: {
    isActiveLink() {
      return this.$route.name === this.routeName;
    },
  },
  mounted() {
    if (this.category) this.setNotifications(this.category.favorite_questions);
  },
  methods: {
    selectPage(routeName) {
      this.$router.push({ name: routeName });
    },
    setNotifications(notifications) {
      this.notifications = notifications;
    },
  },
};
</script>

<style scoped></style>
